import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { TOAST_POSITIONS } from '../../shared-components/constants'
import { TITLE_TYPES } from '../../constants/toast-messages'

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  successHandler(
    message: string,
    position: string = TOAST_POSITIONS.TOP_RIGHT,
    title: string = TITLE_TYPES.NONE
  ) {
    this.toastr.success(message, title, {
      timeOut: 3000,
      positionClass: position,
    })
  }

  errorHandler(
    message: string,
    position: string = TOAST_POSITIONS.TOP_RIGHT,
    title: string = TITLE_TYPES.NONE
  ) {
    this.toastr.error(message, title, {
      timeOut: 3000,
      positionClass: position,
    })
  }
}
